<template>
  <div>
    <div class="ViewConsultants">
      <div class="consultor" v-for="(item, index) in Consultores" :key="index">
        <div class="imagen">
          <img :src="item.Image" />
        </div>
        <p>{{ item.Name }}</p>
        <svg
          @click="NewInteraction"
          style="cursor: pointer"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="34"
          height="34"
          viewBox="0 0 34 34"
        >
          <image
            id="icons8-calendario-100"
            width="34"
            height="34"
            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAFUElEQVR4nO3dXUxbZRgH8P9zerpiGRTGRgG9YFNWGJlL1njjR8K80IVkiSEZMOOFuzJRL1ycl0t2qRfiuFjcEj9udKyNNxNvNGQsMWYhugyNQNmYGk1gbZ0usBbox3m8KDOsK4yec9q+bZ/fDbTv2/d8/NPz8pxzWgAhhBBCCCGEEEIIUUrMoEpus1PBF8Ln/c6IJxaChjlvf+jlSmuzm17IwQFgoW7J4yBtDxj1ldhmt4K9Q6aC3dseT2q1CafRxJy+CeCOK+XsWN+nnNs8bU1LdOhKKv89sznbApkf9bsdsfjr0Iw+MB0AsNOusRVlAIgAuMqEr7wIBagfaauD2hJIOND1CsBnAbStezoBIAYwAdQAgAHcffCVZd1Wh/WHfMaUAeN46+CNH2GB5UBuB7pOEPhDAATCBDOGKa1f9r76axgA5i/s3elwaFEAf3sHQrvWv7ac2/g0tIV93U84ONUL0LsAngKwzMSDLf2zX+e1E9exNKmHL3b2IROGwaD3vEdnzhCBrYxZLug0DGDqTwDn+Lz/00jDvTMAvUlMI5Fg93PN/VOTZsbVzK5QJNi9HYSzAIiZTrYMzHyUK4xW/ca/IEyA8V0ltgEAvXEt6R2YfYvAnwBwM9LnzNYtpg9Za4eqIQA/eAdCz2/UjxlUSe+azbZnftTvdsRjN5GZSw97B0Lf5ju+6XcIAX2ZNcRQrvbwBd/T4YDveiTYuRIO+saiI762XP3KxVa2p+3ItTiDPwYA8Nr+yZPpQAA+CAB6KjWWs9lBIyBtqLm5pZZYu2poNGx+WQrY6vawNpb5gYNmFmMqkOglXx0AN4ClptfmFrPbf/+8vQbA7uajM1/QoSspg4zPAPjNLEsF+WyPrqX/AgBitJpZlqlAkjF2rf26mqt99/E/VpgwFQ52vRMJdrcQ4ySA780sSwX5bE8i9f8+ceVqfxQLh6zNkZEaJOLDzOnrBNqRIMeJQi2rGIq1PQU7uegdnLsFoKBnRoupWNtTsHeIMEcCUYwEohircwjd/XJ/oy1rUgaijcvxjt651flRv9u9mHBlPwaAhG40MJs/C281kB2revKWxTHKhmdJn+Txnpci4dvTqzrqsx8DAJjJykl0q4HcyT5VXflCANC+0ePMqXqKmh1d5hDFSCCKkUAUI4EoRgJRjASiGAlEMQW/lTRf2VVw9vPZ/VXpZxelAuHxHj1T9bKnflH/B8CTQOYKpRGPRVZ1LGe9glToZyelAlm7V7Z9rdqduf98MsYuh4Pu5b6BrfT97FTyOaRYn7soFyUNJHrJVxcOdE6Xch1UU9JAkjF2EVX8XfJ5UWEOeeiaygbXFFTvZ4uSBqKlapbhSCQeuqaSuVHzt3LpZydTE+pmt+5XO6v7puR/ZYkHFeyQpXplXVWVuuqVddVV6qpX1lKpiy2TQBQjgSimkIWh6pV19VTqqlfWUqlXEanUK4xU6jb1s4tU6jb0s5NU6jb0s5PMIYqRQBQjgShGKnX7+tlCKnUb+tlJKnWbSaVeYaq2UldVVVbqKqvKSl1lMocoRgJRTFUEoqVqlgHMlno9tqIqKvVoYzze0Tu34XcLq6QqKnXPkj4J4EULm1Q0UqnbTCr1CiOBKEYCUYwEohgJRDESiGJMBeKspfunsbfzeI8KH61WxjYdm/6jgkcx/bUW4UDnLwD2E9MwNO39bUlN+WsNhbbyWNyJhPMUEd4mwjfN/aEj+Y5hOpDIyL4XWDMuQ40vH1BNUjP42V3HZn/K94WWvvhl4eLeZxykfcDAAatjVYgkgJ/Z0E61HJueKPXKCCGEEEIIIYQQQlSY/wBoYQdRABVYlAAAAABJRU5ErkJggg=="
          />
        </svg>
      </div>
    </div>
    <v-dialog v-model="Interaction" width="350">
      <CreateInteractionVue :info="dataAux" v-on:close="toogle" />
    </v-dialog>
  </div>
</template>
<script>
import CreateInteractionVue from "../CreateInteraction";
export default {
  data: () => ({
    Interaction: false,
    dataAux: {},
  }),
  methods: {
    NewInteraction(data) {
      this.dataAux = data;
      this.Interaction = true;
    },
    toogle(name) {
      this[name] = false;
    },
  },
  components: {
    CreateInteractionVue,
  },
  created() {
    console.log(this.Consultores);
  },
  props: {
    Consultores: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="css" scoped>
.ViewConsultants {
  background: var(--second-color);
  position: relative;
  height: auto;
  z-index: 2;
  box-shadow: 0px 5px 10px 0px var(--twelveth-color);
  border-radius: 5px;
  width: 100%;
  padding: 1px;
}
.consultor {
  position: relative;
  height: 60px;
  background: var(--second-color);
  margin: 15px;
  box-shadow: 0px 0px 20px -8px var(--twelveth-color);
}
.ViewConsultants .consultor .imagen {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 20px;
}
.ViewConsultants .consultor .imagen img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.ViewConsultants .consultor svg {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 5px;
  right: 20px;
}
.ViewConsultants .consultor p {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #0b2257;
}
@media (max-width: 433px) {
  .ViewConsultants .consultor .imagen {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: 20px;
  }
  .ViewConsultants .consultor svg {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 5px;
    right: 20px;
  }
  .ViewConsultants .consultor p {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #0b2257;
  }
}
</style>